export default "96c420ae2377393642feb961d95e5311.png";